export const nFloat = (v) => isNaN(parseFloat(v)) ? 0 : parseFloat(v);
